import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Navbar from "./components/navbar";
import Home from "./pages/home";
import PricePrediction from "./pages/price-prediction";
import FearGreedMeter from "./pages/feargreed-meter";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      <Navbar />
      <Switch>
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>
        <Route path="/home">
          <Home />
        </Route>
        <Route path="/price-prediction">
          <PricePrediction />
        </Route>
        <Route path="/fng">
          <FearGreedMeter />
        </Route>
      </Switch>
    </div>
  );
};

export default App;
